export const PRODUCT_DISCOUNTS_FEATURE_KEY = 'product-discounts';
